// src/BlogPage.jsx
// The /blog route is a two-beat sequence: fly the tunnel, then arrive in the
// scene at the far end. No page chrome until you're through.
import React, { useCallback, useState } from "react";

import BinaryTunnel from "./BinaryTunnel.jsx";
import HeadScene from "./HeadScene.jsx";

import "./BlogPage.css";

const BACK_ICON_URL = `${import.meta.env.BASE_URL}blog/back.svg`;

export default function BlogPage({ onBack, onNavigate, skipTunnel = false }) {
  // 'tunnel' — travelling; 'arrived' — out the far end, head scene running.
  // Reached directly from a blog scene's mini head (rather than the camera
  // flight from home), skip straight to 'arrived' — the page-veil already
  // covers that swap, so there's no white-out for the tunnel to hand off to.
  const [phase, setPhase] = useState(skipTunnel ? "arrived" : "tunnel");

  const handleArrive = useCallback(() => setPhase("arrived"), []);

  return (
    <div className="blog-page">
      {phase === "tunnel" ? (
        <div className="blog-page__stage" aria-hidden="true">
          <BinaryTunnel onArrive={handleArrive} />
        </div>
      ) : (
        <>
          <div className="blog-page__stage" aria-hidden="true">
            <HeadScene onNavigate={onNavigate} />
          </div>

          {/* Picks up where the tunnel's white-out left off and clears, so the
              canvas swap underneath is never visible. Not needed when we
              skipped the tunnel — the page-veil already did that job. */}
          {!skipTunnel && <div className="blog-page__flash" aria-hidden="true" />}

          <button
            type="button"
            className={`blog-page__back ${skipTunnel ? "blog-page__back--instant" : ""}`}
            onClick={onBack}
            aria-label="Back"
          >
            <img src={BACK_ICON_URL} alt="" aria-hidden="true" />
          </button>
        </>
      )}
    </div>
  );
}
